import React from 'react';
import { Typography } from '@mui/material';
import type { SxProps, Theme } from '@mui/material';

interface SectionLabelProps {
  children: React.ReactNode;
  sx?: SxProps<Theme>;
}

/**
 * A compact uppercase section label with a trailing divider line.
 * Used to title subsections inside scenario editor accordions (e.g. Facts,
 * Locations, Personas) in a consistent, low-visual-weight style.
 */
const SectionLabel: React.FC<SectionLabelProps> = ({ children, sx }) => (
  <Typography
    variant="overline"
    sx={{
      fontWeight: 500,
      letterSpacing: '0.06em',
      lineHeight: 1,
      color: 'grey.500',
      mb: 1.25,
      display: 'flex',
      alignItems: 'center',
      gap: 1,
      '&::after': {
        content: '""',
        flex: 1,
        height: '1px',
        backgroundColor: 'grey.200'
      },
      ...sx
    }}
  >
    {children}
  </Typography>
);

export default SectionLabel;
